import { withStylePrefix } from '../common/withStylePrefix';
import { TypographyComponent, typographyTemplate } from './Typography';
import styles from './Typography.styles.scss';
export const typographyDefinition = {
    baseName: 'typography',
    template: typographyTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonTypography = TypographyComponent.compose(typographyDefinition);
